import React from "react"

export default function BlockComponent({
  index,
  content
}) {
  return (
    <div index={index} className={`component-${index}`} dangerouslySetInnerHTML={{ __html: content }}></div>
  )
}